export const STORAGE_KEYS = {
    FIRST_UTM: 'numeo_first_utm_data',
    SIGNUP_START_TIME: 'analytics_signup_start_time',
    ONBOARDING_START_TIME: 'analytics_onboarding_start_time',
    STEP_START_TIME: 'analytics_step_start_time',
    VERIFICATION_START_TIME: 'analytics_verification_start_time',
    VERIFICATION_ATTEMPT: 'analytics_verification_attempt',
    RESEND_COUNT: 'analytics_resend_count',
    LAST_RESEND_TIME: 'analytics_last_resend_time',
    LOGIN_ATTEMPT: 'analytics_login_attempt',
} as const
